import React, { useState } from "react";
import "../CSS/CreateReportForm.css";
import Sidebar from "../Component/Sidebar";

function CreateReportForm() {
  // Basic fields
  const [reportDate, setReportDate] = useState("");
  const [store, setStore] = useState("");
  const [incidentDetails, setIncidentDetails] = useState("");

  // Called / Not Called
  const [callStatus, setCallStatus] = useState(""); // "called" | "notCalled" | ""
  const [selectedReasonCalled, setSelectedReasonCalled] = useState("");
  const [selectedReasonNotCalled, setSelectedReasonNotCalled] = useState("");

  const reasonCalledOptions = [
    "Able to stop",
    "Customer denied",
    "Cashier didn't ask the customer",
    "Customer left the store immediately",
    "Cashier Fraud",
    "Other",
  ];
  const reasonNotCalledOptions = [
    "Network issue",
    "Not sure about stealing",
    "Customer left the store immediately",
    "Cashier Suspicious Activity",
    "Cashier Opened the store",
    "Cashier Closed the store",
    "Other",
  ];

  // Severity
  const [severity, setSeverity] = useState("");
  const [announcementBy, setAnnouncementBy] = useState("");

  // Customer Details
  const [customerCategory, setCustomerCategory] = useState("");
  const [dress, setDress] = useState("");
  const [product, setProduct] = useState("");
  const [pickupTime, setPickupTime] = useState("");
  const [hideTime, setHideTime] = useState("");
  const [exitTime, setExitTime] = useState("");

  // Multiple file uploads
  const [files, setFiles] = useState([]);
  
  // Comments
  const [comment, setComment] = useState("");
  const [incidentRelatesTo, setIncidentRelatesTo] = useState("");
  const [incentiveRule, setIncentiveRule] = useState("");

  // Example comment history
  const [commentHistory] = useState([
    { comments: "Handled politely.", addedBy: "Jane Doe", date: "2025-01-01" },
    { comments: "Escalated to manager.", addedBy: "John Smith", date: "2025-01-05" },
  ]);

  // Handle multiple file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    // Append them to the existing array
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  // Delete a file by index
  const handleFileDelete = (index) => {
    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      reportDate,
      store,
      incidentDetails,
      callStatus,
      selectedReasonCalled,
      selectedReasonNotCalled,
      severity,
      announcementBy,
      customerCategory,
      dress,
      product,
      pickupTime,
      hideTime,
      exitTime,
      files,
      comment,
      incidentRelatesTo,
      incentiveRule,
    };
    console.log("Form submitted:", formData);
    alert("Form submitted! Check the console for data.");
  };

  return (
    <div className="index-box">
      <Sidebar />
      <div className="crf-container">
        <h1 className="crf-title">Create Report</h1>
        <form onSubmit={handleSubmit}>
          {/* Date */}
          <div className="crf-form-group">
            <label className="crf-label" htmlFor="reportDate">
              Select a Date:
            </label>
            <input
              id="reportDate"
              type="date"
              className="crf-input"
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
            />
          </div>

          {/* Store */}
          <div className="crf-form-group">
            <label className="crf-label" htmlFor="storeSelect">
              Select a store:
            </label>
            <select
              id="storeSelect"
              className="crf-select"
              value={store}
              onChange={(e) => setStore(e.target.value)}
            >
              <option value="">Select a store</option>
              <option value="Store A">Store A</option>
              <option value="Store B">Store B</option>
              <option value="Store C">Store C</option>
            </select>
          </div>

          {/* Incident Details */}
          <div className="crf-form-group">
            <label className="crf-label" htmlFor="incidentDetails">
              Enter Incident Details:
            </label>
            <textarea
              id="incidentDetails"
              className="crf-textarea"
              placeholder="Describe the incident..."
              value={incidentDetails}
              onChange={(e) => setIncidentDetails(e.target.value)}
            />
          </div>

          {/* Called/Not Called - radio buttons */}
          <h3 className="crf-sub-heading">Select any reason:</h3>
          <div className="crf-radio-group">
            <label className="crf-radio-item">
              <input
                type="radio"
                name="callStatus"
                value="called"
                checked={callStatus === "called"}
                onChange={(e) => {
                  setCallStatus(e.target.value);
                  setSelectedReasonNotCalled("");
                }}
              />
              Called
            </label>
            <label className="crf-radio-item">
              <input
                type="radio"
                name="callStatus"
                value="notCalled"
                checked={callStatus === "notCalled"}
                onChange={(e) => {
                  setCallStatus(e.target.value);
                  setSelectedReasonCalled("");
                }}
              />
              Not Called
            </label>
          </div>

          {/* Sub-reason for Called */}
          {callStatus === "called" && (
            <div className="crf-form-group">
              <label className="crf-label" htmlFor="reasonCalledDropdown">
                Reason for Called:
              </label>
              <select
                id="reasonCalledDropdown"
                className="crf-select"
                value={selectedReasonCalled}
                onChange={(e) => setSelectedReasonCalled(e.target.value)}
              >
                <option value="">Select reason</option>
                {reasonCalledOptions.map((option, index) => (
                  <option value={option} key={index}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Sub-reason for Not Called */}
          {callStatus === "notCalled" && (
            <div className="crf-form-group">
              <label className="crf-label" htmlFor="reasonNotCalledDropdown">
                Reason for Not Called:
              </label>
              <select
                id="reasonNotCalledDropdown"
                className="crf-select"
                value={selectedReasonNotCalled}
                onChange={(e) => setSelectedReasonNotCalled(e.target.value)}
              >
                <option value="">Select reason</option>
                {reasonNotCalledOptions.map((option, index) => (
                  <option value={option} key={index}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Severity */}
          <h3 className="crf-sub-heading">Select a severity level:</h3>
          <div className="crf-radio-group">
            <label className="crf-radio-item">
              <input
                type="radio"
                value="high"
                checked={severity === "high"}
                onChange={(e) => setSeverity(e.target.value)}
              />
              High
            </label>
            <label className="crf-radio-item">
              <input
                type="radio"
                value="medium"
                checked={severity === "medium"}
                onChange={(e) => setSeverity(e.target.value)}
              />
              Medium
            </label>
            <label className="crf-radio-item">
              <input
                type="radio"
                value="low"
                checked={severity === "low"}
                onChange={(e) => setSeverity(e.target.value)}
              />
              Low
            </label>
          </div>

          {/* Show fields only if severity is chosen */}
          {severity==='high' && (
            <>
              <div className="crf-form-group">
                <label className="crf-label" htmlFor="announcementBy">
                  Announcement By:
                </label>
                <select
                  id="announcementBy"
                  className="crf-select"
                  value={announcementBy}
                  onChange={(e) => setAnnouncementBy(e.target.value)}
                >
                  <option value="">Select any Employee</option>
                  <option value="Employee 1">Employee 1</option>
                  <option value="Employee 2">Employee 2</option>
                  <option value="Employee 3">Employee 3</option>
                </select>
              </div>

              {/* Customer Details */}
              <h3 className="crf-sub-heading">Customer Details:</h3>
              <div className="crf-radio-group">
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    name="customerCategory"
                    value="male"
                    checked={customerCategory === "male"}
                    onChange={(e) => setCustomerCategory(e.target.value)}
                  />
                  Male
                </label>
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    name="customerCategory"
                    value="female"
                    checked={customerCategory === "female"}
                    onChange={(e) => setCustomerCategory(e.target.value)}
                  />
                  Female
                </label>
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    name="customerCategory"
                    value="kid"
                    checked={customerCategory === "kid"}
                    onChange={(e) => setCustomerCategory(e.target.value)}
                  />
                  Kid
                </label>
              </div>

              <div className="crf-form-group">
                <label className="crf-label" htmlFor="dress">
                  Dress:
                </label>
                <input
                  id="dress"
                  type="text"
                  className="crf-input"
                  value={dress}
                  onChange={(e) => setDress(e.target.value)}
                  placeholder="Describe dress/color..."
                />
              </div>

              <div className="crf-form-group">
                <label className="crf-label" htmlFor="product">
                  Product:
                </label>
                <input
                  id="product"
                  type="text"
                  className="crf-input"
                  value={product}
                  onChange={(e) => setProduct(e.target.value)}
                  placeholder="Product name or type..."
                />
              </div>

              <h4>Incident Timings:</h4>
              <div className="crf-form-group">
                <label className="crf-label" htmlFor="pickupTime">
                  Pickup Time:
                </label>
                <input
                  id="pickupTime"
                  type="time"
                  className="crf-input"
                  value={pickupTime}
                  onChange={(e) => setPickupTime(e.target.value)}
                />
              </div>
              <div className="crf-form-group">
                <label className="crf-label" htmlFor="hideTime">
                  Hide Time:
                </label>
                <input
                  id="hideTime"
                  type="time"
                  className="crf-input"
                  value={hideTime}
                  onChange={(e) => setHideTime(e.target.value)}
                />
              </div>
              <div className="crf-form-group">
                <label className="crf-label" htmlFor="exitTime">
                  Exit Time:
                </label>
                <input
                  id="exitTime"
                  type="time"
                  className="crf-input"
                  value={exitTime}
                  onChange={(e) => setExitTime(e.target.value)}
                />
              </div>
            </>
          )}

          {/* Multiple File Upload */}
          <h3 className="crf-sub-heading">Upload media (Images/Videos):</h3>
          <div className="crf-form-group">
            <input
              type="file"
              multiple
              className="crf-file"
              onChange={handleFileChange}
            />
          </div>

          {/* File Preview/Deletion */}
          {files.length > 0 && (
            <ul className="crf-file-list">
              {files.map((file, index) => (
                <li key={index} className="crf-file-list-item">
                  {file.type.startsWith("image/") ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="Preview"
                      width="100"
                    />
                  ) : (
                    <span>{file.name}</span>
                  )}
                  <button
                    type="button"
                    className="crf-file-delete"
                    onClick={() => handleFileDelete(index)}
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          )}

          <hr />

          {/* Comment History */}
          <h2 className="crf-section-title">Employee Comments History</h2>
          <div className="crf-table-container">
            <table className="crf-comments-table">
              <thead>
                <tr>
                  <th>Comments</th>
                  <th>Added By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {commentHistory.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.comments}</td>
                    <td>{item.addedBy}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Add Comment */}
          <div className="crf-form-group">
            <label className="crf-label" htmlFor="comment">
              Enter Comment:
            </label>
            <textarea
              id="comment"
              className="crf-textarea"
              placeholder="Type @ to search..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>

          {/* Incident Relates To */}
          <h3 className="crf-sub-heading">Incident Relates To:</h3>
          <div className="crf-radio-group">
            <label className="crf-radio-item">
              <input
                type="radio"
                value="customer"
                checked={incidentRelatesTo === "customer"}
                onChange={(e) => setIncidentRelatesTo(e.target.value)}
              />
              Customer
            </label>
            <label className="crf-radio-item">
              <input
                type="radio"
                value="cashier"
                checked={incidentRelatesTo === "cashier"}
                onChange={(e) => setIncidentRelatesTo(e.target.value)}
              />
              Cashier
            </label>
          </div>

          {/* Pick rule for incentive (only if relates to customer) */}
          {incidentRelatesTo === "customer" && (
            <>
              <h3 className="crf-sub-heading">Pick rule for incentive:</h3>
              <div className="crf-radio-group">
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    value="theftPrevented"
                    checked={incentiveRule === "theftPrevented"}
                    onChange={(e) => setIncentiveRule(e.target.value)}
                  />
                  Theft Prevented
                </label>
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    value="theftReported"
                    checked={incentiveRule === "theftReported"}
                    onChange={(e) => setIncentiveRule(e.target.value)}
                  />
                  Theft Reported
                </label>
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    value="incidentReported"
                    checked={incentiveRule === "incidentReported"}
                    onChange={(e) => setIncentiveRule(e.target.value)}
                  />
                  Incident Reported
                </label>
                <label className="crf-radio-item">
                  <input
                    type="radio"
                    value="customerDenied"
                    checked={incentiveRule === "customerDenied"}
                    onChange={(e) => setIncentiveRule(e.target.value)}
                  />
                  Customer Denied
                </label>
              </div>
            </>
          )}

          <button type="submit" className="crf-submit-button">
            Submit for Review
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateReportForm;
